/**
 * Created by OLD on 20/11/2015.
 */
define('changeStatusPopupView',[
    'module',
    'jquery',
    'underscore',
    'settings',
    'template!changeStatusPopupTpl',
    'dialogFormView',
    'dropdownCompositeView'
], function(
    module,
    $,
    _,
    Settings,
    viewTpl,
    DialogFormView,
    DropdownCompositeView
) {
    'use strict';

    var OrderStatusPopupView = DialogFormView.extend({
        template: viewTpl,

        regions: {
            dropDownStatus: '.order-status-dropdown-region'
        },

        onRender: function() {
            this.dropDown = new DropdownCompositeView({
                modelProperty: 'statusConst',
                modelDisplayProperty: 'status',
                collection: this.options.orderStatusCollection,
                modelSelectValue: this.options.currentOrderStatus
            });
            this.getRegion('dropDownStatus').show(this.dropDown);
        }
    });

    module.exports = OrderStatusPopupView;
});
